<template>
  <b-form-group
    label="Adres"
    label-for="line2"
  >
    <b-form-input
      id="line2"
      v-model="itemData.line2"
      placeholder="Adres"
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'Title',
  components: { BFormGroup, BFormInput },
  computed: {
    itemData() {
      return this.$store.getters['footerContacts/dataItem']
    },
  },
}
</script>
